module.exports = __webpack_public_path__ + "img/playstore.57fd2d0d.png";